// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "time_off".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { timeOffTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "time_off" table (1:1 with a DB row, on the wire). */
export const timeOffAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    practitionerId: z.string(),
    locationId: z.string().nullable(),
    type: z.enum(timeOffTypeValues),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    allDay: z.boolean(),
    timezone: z.string(),
    rrule: z.string().nullable(),
    recurrenceEndDate: z.string().datetime().nullable(),
    description: z.string().nullable(),
    approved: z.boolean(),
    createdById: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=timeOff.js.map